module.exports = __webpack_public_path__ + "static/media/primera-visita.0b30005f.svg";